import React from "react";
import "./ErrorBoundary.css";

function ErrorBoundary({ error, errorInfo, onRetry, isChunkError }) {
  if (!error) return null;

  const isDevelopment = process.env.NODE_ENV === 'development';
  const isChunkLoadingError = isChunkError || (error.message && (
    error.message.includes('Loading chunk') ||
    error.message.includes('Loading CSS chunk') ||
    error.message.includes('ChunkLoadError') ||
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Unexpected token')
  ));

  return (
    <div className="errorBoundary">
      <div className="errorBoundary__icon">
        <i className="fas fa-exclamation-triangle" />
      </div>
      <h3 className="errorBoundary__title">
        {isChunkLoadingError ? 'Loading Error' : 'Oops! Something went wrong'}
      </h3>
      <p className="errorBoundary__message">
        {isChunkLoadingError 
          ? "A required file failed to load. This is usually due to a cache issue. The page will reload automatically."
          : (error.message || "An unexpected error occurred. Please try again.")
        }
      </p>
      
      {isDevelopment && errorInfo && (
        <details className="errorBoundary__details">
          <summary className="errorBoundary__summary">Error Details (Development Only)</summary>
          <pre className="errorBoundary__stack">
            {errorInfo.componentStack}
          </pre>
        </details>
      )}

      {onRetry && (
        <button 
          className="errorBoundary__retry"
          onClick={onRetry}
        >
          <i className="fas fa-redo" /> Try Again
        </button>
      )}
    </div>
  );
}

export default ErrorBoundary;

